export const wasteDirectionEnum = {
    IN: 1,
    OUT: 2,
};
